import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../base-dialog';

export const DeleteDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  title,
  description,
  confirmLabel,
  cancelLabel,
}: {
  open: boolean;
  onOpenChange: (isDialogOpen: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isPending?: boolean;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
}) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      intent="destructive"
      size="sm"
      isPending={isPending}
      primaryAction={{
        label: confirmLabel ?? t(($) => $.common.delete),
        onClick: onConfirm,
      }}
      secondaryAction={{
        label: cancelLabel ?? t(($) => $.common.cancel),
        onClick: () => onOpenChange(false),
      }}
    />
  );
};
